var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRackEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rack empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 12,
    height: 123
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 40,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 56,
    y: -7,
    width: 12,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 56,
    y: 43,
    width: 12,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 112,
    y: 0,
    width: 12,
    height: 123
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 36,
    y: 69,
    width: 25,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 80,
    y: 69,
    width: 25,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rack-empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-msg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(98.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-55"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 122
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(17.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-56",
    fill: "#EB8181",
    x: 0,
    y: 0,
    width: 40,
    height: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-66",
    fill: "#FFFFFF",
    points: "28 0 28 19 19.6392662 11.8195143 12 19 12 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(60.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-56-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 21
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-65",
    fill: "#87D5FA",
    x: 8,
    y: 10,
    width: 13,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-65-Copy",
    fill: "#87D5FA",
    x: 24,
    y: 10,
    width: 7,
    height: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-67",
    fill: "#87D5FA",
    x: 17,
    y: 57,
    width: 20,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-67-Copy-2",
    fill: "#EB8181",
    x: 60,
    y: 57,
    width: 20,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-55-Copy-2",
    transform: "translate(62.000000, 44.000000) rotate(-270.000000) translate(-62.000000, -44.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 56.5,
    y: -6.5,
    width: 11,
    height: 101
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-55-Copy-3",
    transform: "translate(62.000000, 94.000000) rotate(-270.000000) translate(-62.000000, -94.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 56.5,
    y: 43.5,
    width: 11,
    height: 101
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-55-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 112.5,
    y: 0.5,
    width: 11,
    height: 122
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-67-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 36.5,
    y: 69.5,
    width: 24,
    height: 19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-67-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 80.5,
    y: 69.5,
    width: 24,
    height: 19
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-68-Copy",
    fill: "#EB8181",
    x: 40,
    y: 73,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-68-Copy-2",
    fill: "#87D5FA",
    x: 84,
    y: 73,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,81.5 L47.5,81.5",
    id: "Line-42-Copy-2",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,81.5 L91.5,81.5",
    id: "Line-42-Copy-4",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,84.5 L43.5,84.5",
    id: "Line-42-Copy-3",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,84.5 L87.5,84.5",
    id: "Line-42-Copy-5",
    stroke: "#64808C",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRackEmpty);
export default __webpack_public_path__ + "static/media/rackEmpty.d1e1d8e2009fc92c844077ec30439598.svg";
export { ForwardRef as ReactComponent };